import React, { Component } from "react";
import { Badge, Spinner } from "reactstrap";
import { FaShoppingCart } from 'react-icons/fa';

export default class CartIcon extends Component {

  getBadgeColor() {
    if (this.props.waiting) {
      return "secondary";
    }
    return this.props.number === 0 ? "secondary" : "danger";
  }

  renderBadgeContent() {
    if (this.props.waiting) {
      return <Spinner style={{ width: '0.5rem', height: '0.5rem' }} type="grow" />;
    }
    return this.props.number;
  }

  render() {
    return (
      <div className="notif-container">
        <FaShoppingCart className="notif-icon pr-1" size={25} />
        <Badge
          pill
          color={this.getBadgeColor()}
          className="notif-counter"
        >
          {this.renderBadgeContent()}
        </Badge>
      </div>
    );
  }
}
